/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A flexible carousel UI component for VDK Web. (@accedo/vdkweb-carousel) 6.0.4
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultOptions = {
  dots: true,
  infinite: false,
  speed: 500,
  draggable: false
};
var CarouselLayoutManager = /*#__PURE__*/function () {
  function CarouselLayoutManager(settings) {
    _classCallCheck(this, CarouselLayoutManager);
    this.options = _objectSpread(_objectSpread({}, defaultOptions), settings);
    this.itemWidth = settings.itemWidth;
    this.itemHeight = settings.itemHeight;
  }
  _createClass(CarouselLayoutManager, [{
    key: "getOptions",
    value: function getOptions() {
      return this.options;
    }
  }, {
    key: "getResponsiveSettings",
    value: function getResponsiveSettings() {
      if (this.options.responsive) {
        return this.options.responsive;
      }
      var breakpoints = CarouselLayoutManager._getBreakpoints(this.itemWidth);
      return breakpoints.map(function (breakpoint) {
        var numberOfItems = CarouselLayoutManager._calculateNumberOfItems(breakpoints);
        return {
          breakpoint: breakpoint,
          settings: {
            slidesToShow: numberOfItems[breakpoint],
            slidesToScroll: numberOfItems[breakpoint]
          }
        };
      });
    }
  }], [{
    key: "_getBreakpoints",
    value: function _getBreakpoints(breakpointWidth) {
      var maxBreakpoints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
      var veryBigNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000000;
      var startBreakMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 470;
      var bps = [];
      for (var i = 1; i <= maxBreakpoints; i += 1) {
        var bp = i * breakpointWidth + startBreakMargin;
        bps.push(bp);
      }
      if (veryBigNumber > maxBreakpoints * breakpointWidth) {
        bps.push(veryBigNumber);
      }
      return bps;
    }
  }, {
    key: "_calculateNumberOfItems",
    value: function _calculateNumberOfItems(bps) {
      var bpMap = bps.reduce(function (acc, bp, index) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, bp, index + 1));
      }, {});
      return _objectSpread({}, bpMap);
    }
  }]);
  return CarouselLayoutManager;
}();
export { CarouselLayoutManager as default };